import {
  useEffect,
  useState
} from 'react'
import { Stack } from '@chakra-ui/react'
import { CreateComment } from 'components/Notifications/CommunityBlogs/Comments/CreateComment'
import { CommentsForPost } from 'components/Notifications/CommunityBlogs/Comments/CommentsForPost'
import { COLORS } from 'utils/styles'
import { SUCCEEDED } from 'utils/constants'

export const Comments = ({
  from,
  activeProfile,
  chosenBlogIndex,
  comments,
  getCommentsStatus,
  postCommentsStatus,
  putCommentsStatus,
  blogParent,
  blogRepostData,
  commentsOption,
  widen,
  GoToMarker = false
}) => {
  const stickyHeader = document.querySelector('#stickyHeader' + blogParent[0]?.id)
  const [editCommentData, setEditCommentData] = useState({})
  const [stickyHeaderHeight, setStickyHeaderHeight] = useState(stickyHeader?.offsetHeight)
  const parentData = blogParent[blogParent.length - 1]

  const handleMinHeight = () => {
    let wholeParent = document.querySelector('#blog-panel')
    const minusToHeight = getCommentsStatus === SUCCEEDED ? 39 : 10

    if (wholeParent) {
      return wholeParent?.offsetHeight - stickyHeaderHeight - minusToHeight
    }

    wholeParent = document.querySelector('.leaflet-popup-content')
    if (wholeParent) {
      return wholeParent?.offsetHeight - stickyHeaderHeight - minusToHeight
    }

    return '100svh'
  }

  useEffect(() => {
    setStickyHeaderHeight(100)
    setTimeout(() => setStickyHeaderHeight(stickyHeader?.offsetHeight), 800)
  }, [widen])

  return (
    <Stack
      key={parentData?.comment_id ?? parentData?.id}
      margin="-15px 0"
      padding="20px 5px 10px 5px"
      background={COLORS.darkGray}
      minHeight={handleMinHeight()}
    >
      <Stack overflow="hidden">
        {
          getCommentsStatus === SUCCEEDED || comments.length
            ? (
              <CreateComment
                activeProfile={activeProfile}
                blogParent={blogParent}
                getCommentsStatus={getCommentsStatus}
                type={commentsOption.type}
                postCommentsStatus={postCommentsStatus}
                putCommentsStatus={putCommentsStatus}
                editCommentData={editCommentData}
                setEditCommentData={setEditCommentData}
              />
            ) : ''
        }

        <CommentsForPost
          from={from}
          activeProfile={activeProfile}
          blogRepostData={blogRepostData}
          chosenBlogIndex={chosenBlogIndex}
          comments={comments}
          getCommentsStatus={getCommentsStatus}
          setEditCommentData={setEditCommentData}
          commentsOption={commentsOption}
          blogParent={blogParent}
          widen={widen}
          GoToMarker={GoToMarker}
        />
      </Stack>
    </Stack>
  )
}
